export type LoadingProps = {};

function Loading({}: LoadingProps) {
  return <div>Loading</div>;
}

export default Loading;
